module.exports = __webpack_public_path__ + "static/media/050-catwoman.9a3a6776.svg";